import React from 'react';
import { CtaButton } from './CtaButton';
export function PurchaseSection() {
  return <section id="compra" className="bg-[#faf6f0] text-gray-900 py-24 px-4 border-t-8 border-[#c9a96e] scroll-mt-10" data-id="element-170">
      <div className="max-w-4xl mx-auto text-center" data-id="element-171">
        <h2 className="font-oswald text-5xl md:text-6xl font-bold mb-8 uppercase tracking-tight text-[#2a1f14]" data-id="element-172">
          Empieza hoy tu camino hacia una mente más tranquila
        </h2>

        <p className="font-opensans text-2xl md:text-3xl text-gray-700 mb-12 font-semibold leading-relaxed" data-id="element-173">
          Accede ahora al Mega Pack Claridad Mental y descubre una forma
          diferente de relacionarte con tu mente.
        </p>

        <div className="bg-white p-8 md:p-12 rounded-2xl shadow-2xl border-2 border-[#c9a96e] max-w-2xl mx-auto relative" data-id="element-174">
          <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-[#b5634b] text-white font-oswald font-bold px-6 py-2 rounded-full text-xl uppercase shadow-lg whitespace-nowrap" data-id="element-175">
            Acceso Inmediato
          </div>

          <div className="py-8" data-id="element-176">
            <CtaButton text="QUIERO ACCEDER AL MEGA PACK" className="w-full text-2xl md:text-4xl py-6" data-id="element-177" />
          </div>

          <div className="flex justify-center items-center gap-4 mt-6 text-gray-500 font-opensans text-sm" data-id="element-178">
            <svg className="w-6 h-6 text-[#7a9e7a]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-179">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-180"></path>
            </svg>
            <span data-id="element-181">Pago 100% Seguro y Encriptado</span>
          </div>
        </div>
      </div>
    </section>;
}